import * as React from 'react'
import LargeNumber from '../../../helper/large-number'

interface Props {
    message?: {
        args: {
            ct: number
        }
    }
}
export default class StripePaymentInit extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = <p></p>

        if (message) {
            intro = (
                <p>
                    There were <LargeNumber value={message.args.ct} class="" /> calls to the Stripe Payment API.
                </p>
            )
        }

        return (
            <div>
                {intro}
                <p>
                    The Stripe Payment Module for Magento 2 may eagerly update and refresh account data via the Stripe API whenever its
                    loaded via dependency injection. This configuration update is performed even when the Stripe API is not needed on the
                    page.
                </p>
            </div>
        )
    }
}
